import { createApi } from '@reduxjs/toolkit/query/react';
import { waServicesQuery } from './baseQueries';
import { RecordResponse } from '../models/ServiceTypes';

interface DashboardSidePanel {
  DashboardSidePanelId: number;
  PanelKey: string;
  Title: string;
  SortOrder: number;
  IsVisible: boolean;
  Settings: string | null;
}

export interface SocialMediaSettings {
  Twitter?: string;
  Facebook?: string;
  LinkedIn?: string;
  Instagram?: string;
}

type DashboardSidePanelsResponse = RecordResponse<DashboardSidePanel>;

export const socialSettingsApi = createApi({
  reducerPath: 'socialSettingsApi',
  baseQuery: waServicesQuery,
  endpoints: (builder) => ({
    getSocialMediaSettings: builder.query<SocialMediaSettings, void>({
      queryFn: async (_arg, _api, _extra, baseQuery) => {
        const result = await baseQuery({
          url: `/api/user/dashboardSidePanels`,
          method: 'GET',
        });

        if (result.error) {
          return { error: result.error };
        }

        const data = result.data as DashboardSidePanelsResponse;
        const socialPanel = data.Records?.find(
          (panel) => panel.PanelKey === 'investor-social',
        );

        if (!socialPanel?.Settings) {
          return { data: {} };
        }

        try {
          const settings = JSON.parse(
            socialPanel.Settings,
          ) as SocialMediaSettings;
          return { data: settings };
        } catch {
          return { data: {} };
        }
      },
      keepUnusedDataFor: 24000,
    }),
  }),
});

export const { useGetSocialMediaSettingsQuery } = socialSettingsApi;
